import { createSelector, createSlice } from "@reduxjs/toolkit";
import { loadDrillDownConfiguration } from "../thunks/drillDownConfigurationThunks";
import { DrillDownConfigurationState } from "../types/drillDownConfigurationState.types";
import { RootState } from "../types/store.types";
import { DRILL_DOWN_CONFIGURATION_SLICE_NAME } from "../utils/storeUtils";

const initialState: DrillDownConfigurationState = {
  configurations: [],
  loading: false,
  loadingFailed: false,
  error: undefined,
};

const drillDownConfigurationSlice = createSlice({
  name: DRILL_DOWN_CONFIGURATION_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadDrillDownConfiguration.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(loadDrillDownConfiguration.fulfilled, (state, action) => {
      state.loading = false;
      state.configurations.push(action.payload);
    });
    builder.addCase(loadDrillDownConfiguration.rejected, (state, action) => {
      state.loading = false;
      state.loadingFailed = true;
      state.error = action.error.message;
    });
  },
});

export const selectDrillDownConfiguration = createSelector(
  (state: RootState) => state.metaData.dataSetId,
  (state: RootState) => state.drillDownConfiguration.configurations,
  (dataSetId, configurations) => configurations.find((c) => c.dataSetId === dataSetId) ?? null
);

const EMPTY_DIMENSIONS: string[] = [];

export const selectDrillDownDefaultDimensions = createSelector(
  (state: RootState) => state.metaData.dataSetId,
  (state: RootState) => state.drillDownConfiguration.configurations,
  (dataSetId, configurations) => {
    const config = configurations.find((c) => c.dataSetId === dataSetId);
    return config?.drillDownConfiguration.defaultDimensions ?? EMPTY_DIMENSIONS;
  }
);

export const selectDrillDownConfigurationLoading = (state: RootState) => state.drillDownConfiguration.loading;
export const selectDrillDownConfigurationLoadingFailed = (state: RootState) =>
  state.drillDownConfiguration.loadingFailed;
export const selectDrillDownConfigurationError = (state: RootState) => state.drillDownConfiguration.error;

export default drillDownConfigurationSlice.reducer;
